export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-shield-51abf04ec9afd3bd531b12bb99bd1444.svg";